export const InitFooterButtonTypes = {
  CREATE : "create",
  EDIT : "edit",
  DELETE : "delete",
  CANCEL : "cancel"
}

Object.freeze(InitFooterButtonTypes);